import { useEffect, useState } from 'react';

import Form from 'components/Form';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Grid,
  Typography,
  Box,
  useTheme,
} from '@mui/material';
import RowContainer from '../../components/RowContainer';
import SectionTitle from '../../components/SectionTitle';
import { IEtube } from 'apis/survey/type';

interface Props extends IFormRegister, IFormValues, IFormWatch {
  disabled?: boolean;
}

const Etube = (props: Props) => {
  const { disabled, getValues, setValue } = props;
  const { palette } = useTheme();

  const labels = ['종류', '길이', 'Fr', 'Vent 유/무', '삽관 시행자'];
  const registerIds = ['type', 'length', 'french', 'vent_exists', 'performer'];

  const [dialysisRecord, setDialysisRecord] = useState<IEtube[]>([
    {
      record_date: '',
      insertion_date: '',
      type: '',
      length: '',
      french: '',
      vent_exists: '',
      performer: '',
      extubation: '',
    },
    {
      record_date: '',
      insertion_date: '',
      type: '',
      length: '',
      french: '',
      vent_exists: '',
      performer: '',
      extubation: '',
    },
    {
      record_date: '',
      insertion_date: '',
      type: '',
      length: '',
      french: '',
      vent_exists: '',
      performer: '',
      extubation: '',
    },
    {
      record_date: '',
      insertion_date: '',
      type: '',
      length: '',
      french: '',
      vent_exists: '',
      performer: '',
      extubation: '',
    },
  ]);

  useEffect(() => {
    if (getValues('etube_information'))
      setDialysisRecord(getValues('etube_information'));
    else setValue('etube_information', dialysisRecord);
  }, []);

  return (
    <>
      <SectionTitle title="E-tube" />
      <RowContainer xs={12}>
        <Grid item flex={1}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small">
            <TableBody>
              <TableRow
                key={'기록 일시'}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  기록 일시
                </TableCell>
                {Array(4)
                  .fill(0)
                  .map((_, idx) => (
                    <TableCell key={idx}>
                      <Form.MuiTextField
                        required={false}
                        type="date"
                        disabled={disabled}
                        value={
                          dialysisRecord ? dialysisRecord[idx].record_date : ''
                        }
                        onChange={e => {
                          let newRecord = dialysisRecord
                            ? [...dialysisRecord]
                            : [];
                          newRecord[idx]['record_date'] = e.target.value;
                          setDialysisRecord(newRecord);
                          setValue('etube_information', newRecord);
                        }}
                      />
                    </TableCell>
                  ))}
              </TableRow>
              <TableRow
                key={'삽입 일시'}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  삽입 일시
                </TableCell>
                {Array(4)
                  .fill(0)
                  .map((_, idx) => (
                    <TableCell key={idx}>
                      <Form.MuiTextField
                        required={false}
                        type="date"
                        disabled={disabled}
                        value={
                          dialysisRecord
                            ? dialysisRecord[idx].insertion_date
                            : ''
                        }
                        onChange={e => {
                          let newRecord = dialysisRecord
                            ? [...dialysisRecord]
                            : [];
                          newRecord[idx]['insertion_date'] = e.target.value;
                          setDialysisRecord(newRecord);
                          setValue('etube_information', newRecord);
                        }}
                      />
                    </TableCell>
                  ))}
              </TableRow>
              {labels.map((label, labelIdx) => (
                <TableRow
                  key={label}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row" sx={{ width: '150px' }}>
                    {label}
                  </TableCell>
                  {Array(4)
                    .fill(0)
                    .map((_, idx) => (
                      <TableCell key={idx}>
                        <Form.MuiTextField
                          value={
                            dialysisRecord
                              ? dialysisRecord[idx][registerIds[labelIdx]]
                              : ''
                          }
                          onChange={e => {
                            let newRecord = dialysisRecord
                              ? [...dialysisRecord]
                              : [];
                            newRecord[idx][registerIds[labelIdx]] =
                              e.target.value;
                            setDialysisRecord(newRecord);
                            setValue('etube_information', newRecord);
                          }}
                          required={false}
                          disabled={disabled}
                        />
                      </TableCell>
                    ))}
                </TableRow>
              ))}
              <TableRow
                key={'발관 일시'}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  발관 일시
                </TableCell>
                {Array(4)
                  .fill(0)
                  .map((_, idx) => (
                    <TableCell key={idx}>
                      <Form.MuiTextField
                        required={false}
                        type="date"
                        disabled={disabled}
                        value={
                          dialysisRecord ? dialysisRecord[idx].extubation : ''
                        }
                        onChange={e => {
                          let newRecord = dialysisRecord
                            ? [...dialysisRecord]
                            : [];
                          newRecord[idx]['extubation'] = e.target.value;
                          setDialysisRecord(newRecord);
                          setValue('etube_information', newRecord);
                        }}
                      />
                    </TableCell>
                  ))}
              </TableRow>
            </TableBody>
          </Table>
          <Box
            display={'flex'}
            flexDirection={'column'}
            alignItems={'flex-end'}
            sx={{ marginTop: '20px', width: '98%' }}
          >
            <Typography
              sx={{ fontSize: '12px', color: `${palette.primary.main}` }}
            >
              해당 기록지는 가톨릭대학교 간호대학의 협조를 통해 제작하였습니다
            </Typography>
          </Box>
        </Grid>
      </RowContainer>
    </>
  );
};

export default Etube;
